import React from "react";

import { NewTab } from "../../../components";
import Ats from "./Ats";
import { useModuleAccess } from "../../../hooks";

const Reports = () => {
  const tabList = [
    {
      title: "ATS",
      page: <Ats />,
      type: "main",
      id: "reports_ats",
    },
    {
      title: "Favourite Reports",
      page: <Ats isFavourite={true}/>,
      type: "main",
      id: "fav_reports_ats",
    }
  ];

  const filteredTabs = useModuleAccess({
    allTabs: tabList,
    parentId: "reports",
  });
  return (
    <div className="flex-1 flex  overflow-hidden">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="outlined"
        mode="url"
        tabId="reports"
      />
    </div>
  );
};

// return (
//   <div className="my-5 flex flex-col gap-5">
//     <NewTab tabs={tabList} color="black" variant="text" />
//   </div>
// );
//};

export default Reports;
